module.exports = "<div class=\"page-not-found-page\">\n    <h1>{{ 'system.page_not_found' | translate }}</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found-page/page-not-found-page.component.html
// module id = ./src/app/pages/page-not-found-page/page-not-found-page.component.html
// module chunks = main